import { Box, Typography, useMediaQuery } from '@mui/material';
import * as React from 'react';

export interface IColoredGadgetProps {
    upperText: string;
    icon: React.ReactNode;
    lowerText: string;
}

const ColoredGadget = (props: IColoredGadgetProps) => {
    const biggerThan500 = useMediaQuery('(min-width:500px)');

    return (
        <Box
            sx={{ border: '1px solid', borderColor: 'primary.main' }}
            borderRadius={4}
            display='flex'
            p={1}
            height={'100%'}
            flexDirection='column'
            justifyContent={'space-between'}
            alignItems={'start'}
        >
            <Typography ml={1} sx={{ fontSize: '20px', fontWeight: 500 }}>{props.upperText}</Typography>
            <Box mt={1} px={1} width='100%' display='flex' flexWrap={'wrap'} justifyContent={'space-between'} alignItems={'center'}>
                {/* <Box display='flex' alignItems='center'> */}
                {biggerThan500 && <Box>
                    {props.icon}
                </Box>}
                <Box>
                    <Typography sx={{ fontSize: '22px', fontWeight: 700 }} color='primary'>{props.lowerText}</Typography>
                </Box>
                {/* </Box> */}
            </Box>

        </Box>
    );
};

export default ColoredGadget;